import { Workbook } from "exceljs";
import { IncentiveDisbursementResponse } from "../../services/reports.service";
import { applyHeaderStyle, currencyFmt, rateFillArgb } from "./workbook-styles";

export const addIncentiveDisbursementSheets = (
	workbook: Workbook,
	data: IncentiveDisbursementResponse,
	currencyMask: string,
): void => {
	const numFmt = currencyFmt(currencyMask);

	const perEnrollment = workbook.addWorksheet("Per enrollment");
	perEnrollment.columns = [
		{ header: "Participant", key: "participantName", width: 28 },
		{ header: "Org unit", key: "orgUnit", width: 22 },
		{ header: "Researcher", key: "researcher", width: 22 },
		{ header: "Potential", key: "potential", width: 12 },
		{ header: "Earned", key: "earned", width: 12 },
		{ header: "Received", key: "received", width: 12 },
		{ header: "Engagement %", key: "engagementRate", width: 14 },
	];
	applyHeaderStyle(perEnrollment.getRow(1));

	for (const row of data.byEnrollment) {
		const r = perEnrollment.addRow(row);
		r.getCell("potential").numFmt = numFmt;
		r.getCell("earned").numFmt = numFmt;
		r.getCell("received").numFmt = numFmt;
		r.getCell("engagementRate").numFmt = "0.0";
		const rate = rateFillArgb(row.engagementRate);
		if (rate) {
			r.getCell("engagementRate").fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: rate },
			};
		}
	}

	const daily = workbook.addWorksheet("Daily breakdown");
	daily.columns = [
		{ header: "Day", key: "day", width: 8 },
		{ header: "Earned", key: "earned", width: 12 },
		{ header: "Potential", key: "potential", width: 12 },
	];
	applyHeaderStyle(daily.getRow(1));

	for (const row of data.byDay) {
		const r = daily.addRow(row);
		r.getCell("earned").numFmt = numFmt;
		r.getCell("potential").numFmt = numFmt;
	}
};
